import React from 'react';

import DropDown from '../../common/DropDown';

export type TBulkActions = {
    isListSelected: boolean;
    defaultSelectionFromParam?: string;
    onListAction: (key: string, val: { value: string }) => void;
    user: any;
};

export function AvailabilityListActions({
    isListSelected,
    defaultSelectionFromParam,
    onListAction,
    user,
}: TBulkActions) {

    const options = [];

    if (user.isAgent) {
            options.push(
            {
                label: 'Rename list...',
                value: 'rename_availability_list',
            },
            {
                label: 'Delete list...',
                value: 'delete_availability_list',
            }
        );
    }

    return (
        isListSelected && (
            <div className="bookings-bulk-actions">
                    <DropDown
                        id="bulk-actions-menu"
                        filterKey="action"
                        defaultSelectionFromParam={defaultSelectionFromParam}
                        options={options}
                        defaultSelection={options[0]}
                        onFilterChange={onListAction}
                        renderSelected={() => (
                            <div className="dropdown-placeholder">
                                List action...
                            </div>
                        )}
                        renderOption={(option: {
                            label: string;
                            value: string;
                        }) => <div>{option.label}</div>}
                    />
            </div>
        )
    );
}
